import {getDocumentById} from '../components/prosemirror-editor/firestore/documents';
import {
    apiMetaToHeaderData,
    applyHeaderDataToYDocMap,
    isDocumentMetaHeaderEmpty,
} from './documentHeaderMeta';

/**
 * When Yjs documentMeta is empty but PostgreSQL report.meta has data, seed the Y.Map once.
 * Ensures header fields survive refresh even if the collab snapshot omitted documentMeta.
 *
 * @param {string} documentId
 * @param {import('yjs').Doc} ydoc
 * @param {import('yjs').Map} yDocMeta
 * @returns {Promise<boolean>} whether hydration ran
 */
export async function hydrateDocumentMetaFromApi(documentId, ydoc, yDocMeta) {
    if (!documentId || !ydoc || !yDocMeta || !isDocumentMetaHeaderEmpty(yDocMeta)) {
        return false;
    }

    const report = await getDocumentById(documentId);
    if (!report) {
        return false;
    }

    const headerData = apiMetaToHeaderData(report.meta);
    if (report.title) {
        headerData.title = report.title;
    }

    const hasApiMeta = !isDocumentMetaHeaderEmpty({
        get: (key) => headerData[key],
    });
    if (!hasApiMeta && !headerData.title) {
        return false;
    }

    ydoc.transact(() => {
        applyHeaderDataToYDocMap(yDocMeta, headerData);
    }, 'meta-hydrate');

    return true;
}
